import {
  ensureLeadingSlash,
  stringEmpty,
  uppercase,
  safeParse,
} from './display'

const TEMP_HOSTNAME = 'xyz.com'
const REMOVABLE_KEYS = ['shop', 'host']

export const VERIFYD_HEADERS = {
  PUBLIC_KEY: 'X-Public-Key',
  EPHEMERAL_KEY: 'X-Ephemeral-Key',
  AUTHORIZATION: 'X-Authorization',
  AUTHORIZATION_TIMESTAMP: 'X-Authorization-Timestamp',
}

const CONTENT_TYPE_HEADER = 'Content-Type'

export const CONTENT_TYPES = {
  APPLICATION_JSON: 'application/json',
}

export const getRequestMethod = (body, _method) => {
  const method = _method ?? (body ? 'POST' : 'GET')

  return uppercase(method)
}

export const prepareRequestOptions = ({ method: _method, body: _body, headers: _headers, ...requestOptions } = {}) => {
  const method = getRequestMethod(_body, _method)

  const _contentType = _headers?.[CONTENT_TYPE_HEADER.toLowerCase()]
  const headers = {
    [CONTENT_TYPE_HEADER]: _contentType || CONTENT_TYPES.APPLICATION_JSON,
    ..._headers,
  }

  let body = _body
  if (body && headers[CONTENT_TYPE_HEADER].startsWith(CONTENT_TYPES.APPLICATION_JSON)) {
    body = JSON.stringify(safeParse(body))
  }

  return {
    method,
    headers,
    ...(body && (method !== 'GET')) && { body },
    ...requestOptions,
  }
}

const convertToURL = (uri) => {
  if (stringEmpty(uri)) {
    return undefined
  }

  const protocolRegex = /^(https?:\/\/).+/i

  if (!protocolRegex.test(uri)) {
    return new URL(`https://${TEMP_HOSTNAME}${ensureLeadingSlash(uri)}`)
  }

  return new URL(uri)
}

export const normalizeURIParts = (uri) => {
  const urlObject = convertToURL(uri)
  if (!urlObject) {
    return undefined
  }

  REMOVABLE_KEYS.forEach((key) => urlObject.searchParams.delete(key))

  return {
    ...(urlObject.hostname !== TEMP_HOSTNAME) && {
      origin: urlObject.origin,
    },
    pathname: urlObject.pathname,
    search: urlObject.search,
  }
}
